import {
    HttpResponse,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    PartyActivityModel,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class PartyActivitiesDataService implements CrudService<PartyActivityModel, PartyActivityModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<PartyActivityModel>): Promise<CrudListResponse<PartyActivityModel>> {
        return ApiService.api.getPartyActivityBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PartyActivityModel>> {
        return ApiService.api.getPartyActivityById(id, params);
    }

    create(item: PartyActivityModel, params?: RequestParams): Promise<CrudResponse<PartyActivityModel>> {
        return ApiService.api.insertPartyActivity(item, params);
    }

    update(item: PartyActivityModel, params?: RequestParams): Promise<PartyActivityModel> {
        return ApiService.api.updatePartyActivity(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PartyActivityModel> {
        return ApiService.api.patchPartyActivity(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PartyActivityModel>): Promise<CrudListResponse<PartyActivityModel>> {
        return ApiService.api.deletePartyActivities(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<PartyActivityModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
